import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { setNewRating } from '../../apiCalls/product'
import { toast } from "react-toastify";

const colors = {
  orange: "#FFBA5A",
  grey: "#a9a9a9",
};

const RatingForm = ({productId, user}) => {
  // const [currentValue, setCurrentValue] = useState(0);
  const [hoverValue, setHoverValue] = useState(undefined);
  const stars = Array(5).fill(0);

  const handleClick = (value) => {
    setFormValues({ ...formValues, rating: value });
  };

  const handleMouseOver = (newHoverValue) => {
    setHoverValue(newHoverValue);
  };

  const handleMouseLeave = () => {
    setHoverValue(undefined);
  };

  const initialValues = {
    fullname: "",
    email: "",
    reviewMessage: "",
    rating: 0,
    userId: user?._id,
    productId: productId,
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [submit, setSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target; // take name and value from input in destructring
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setFormErrors(validate(formValues));
    if (formValues.fullname && formValues.email && formValues.reviewMessage) {
      const res = await setNewRating(formValues);
      if(res.status === 200){
        toast.success(`Thanks for Your Valuable Feedback`);
      }
      // console.log(res, 'res for rating')
    }
    setSubmit(true);
  };

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    //first name
    if (
      !/^[a-z A-Z0-9]+$/.test(values.fullname) ||
      /^[ ]+$/.test(values.fullname)
    ) {
      errors.fullname = "Name is not valid";
    }

    if (!values.fullname) {
      errors.fullname = "Name is Required";
    }

    //email
    if (!values.email) {
      errors.email = "Email is Required";
    }
    if (!regex.test(values.email) && values.email) {
      errors.email = "Email is not valid";
    }

    //message
    if (!values.reviewMessage) {
      errors.reviewMessage = "Message is Required";
    }

    return errors;
  };

  return (
    <>
      <div className="ec-ratting-content">
        <div className="ec-ratting-form">
          <form>
            <div className="payment-data">
              <div className="payment-form">
                <div className="from-tab">
                  <div className="form-block-title mb-1">
                    <h2 className="title">Add a Review</h2>
                  </div>

                  {stars.map((_, index) => {
                    return (
                      <FaStar
                        key={index}
                        size={24}
                        onClick={() => handleClick(index + 1)}
                        onMouseOver={() => handleMouseOver(index + 1)}
                        onMouseLeave={handleMouseLeave}
                        color={
                          (hoverValue || formValues.rating) > index
                            ? colors.orange
                            : colors.grey
                        }
                        className="rating-star"
                      />
                    );
                  })}

                  <div className="input-groups mb-1">
                    <div className="input-field w-100">
                      <label>
                        Full Name<span className="text-red">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Your Name"
                        name="fullname"
                        value={formValues.fullname}
                        onChange={handleChange}
                      />
                      <small className="text-red">{formErrors.fullname}</small>
                    </div>
                  </div>
                  <div className="input-groups mb-1">
                    <div className="input-field w-100">
                      <label>
                        Email<span className="text-red">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formValues.email}
                        placeholder="rohit892051182@gmail.com"
                        onChange={handleChange}
                      />
                      <small className="text-red">{formErrors.email}</small>
                    </div>
                  </div>
                  <div className="input-groups mb-1">
                    <div className="input-field address">
                      <label>Give your Reviews.</label>
                      <textarea
                        name="reviewMessage"
                        placeholder="Your Reviews here..."
                        rows="3"
                        value={formValues.reviewMessage}
                        onChange={handleChange}
                      />
                      <small className="text-red">
                        {formErrors.reviewMessage}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="review-submit">
                <button className="btn w-100" onClick={handleSubmit}>
                  submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default RatingForm;
